"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as o } from "react";
import e from "../components/Icon/SvgIcon.js";
const r = (a) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.25 5.771A2.524 2.524 0 0 1 7.771 3.25h7.721a2.524 2.524 0 0 1 2.52 2.521v12.458a2.524 2.524 0 0 1-2.52 2.521H7.771a2.524 2.524 0 0 1-2.521-2.521zM7.771 22h7.721a3.774 3.774 0 0 0 3.77-3.771V5.771A3.774 3.774 0 0 0 15.492 2H7.771A3.775 3.775 0 0 0 4 5.771v12.458A3.775 3.775 0 0 0 7.771 22m2.2-9.372L8.72 11.41l1.727-.25a.62.62 0 0 0 .47-.343l.772-1.563.771 1.563a.62.62 0 0 0 .471.342l1.726.251-1.25 1.218a.63.63 0 0 0-.179.553l.296 1.718-1.544-.81a.62.62 0 0 0-.582 0l-1.544.81.295-1.718a.63.63 0 0 0-.18-.553m-1.313 3.92a.62.62 0 0 0 .658.047l2.374-1.248 2.374 1.248a.623.623 0 0 0 .907-.659l-.454-2.643 1.921-1.872a.627.627 0 0 0-.347-1.066l-2.654-.385-1.187-2.406c-.21-.427-.91-.427-1.12 0L9.942 9.97l-2.655.385a.625.625 0 0 0-.346 1.066l1.92 1.872-.453 2.643a.62.62 0 0 0 .25.612",
        clipRule: "evenodd"
      }
    )
  }
), i = o(r);
export {
  i as Rewards,
  i as default
};
